
export function validateHex(hex: string) {
  return /^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
}

export function hex2rgba(hex: string, alpha: number): string {
  if (validateHex(hex)) {
    const r = parseInt(hex.length > 4 ? hex.slice(1, 3) : hex[1].repeat(2), 16);
    const g = parseInt(hex.length > 4 ? hex.slice(3, 5) : hex[2].repeat(2), 16);
    const b = parseInt(hex.length > 4 ? hex.slice(5, 7) : hex[3].repeat(2), 16);
    const a = Math.max(Math.min(alpha, 1));
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
  throw new Error('Wrong Hex Format');
}
